import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InternalError extends CodedError {
  static get errorName() {
    return errorCodes.internalError.code;
  }

  static status = errorCodes.internalError.status;
  static message = `${errorCodes.internalError.message} ${errorCodes.internalError.code}`;

  constructor(message: string = errorCodes.internalError.message) {
    super(message);
    this.code = errorCodes.internalError.code;
    this.message = `${message} ${errorCodes.internalError.code}`;
    this.name = errorCodes.internalError.name;
    this.status = errorCodes.internalError.status;
  }
}
